import styled from 'styled-components';

export const Label = styled.div`
  display: flex;
  align-items: center;
  grid-column-gap: 5px;
  color: #b1b5c4;
  user-select: none;
  font-size: 12px;
  font-weight: 700;
`;
